<template>
    <div :class="formGroupClasses">
        <label v-if="label" :for="name">{{ label }}</label>
        <div :class="holderClasses">
            <select 
                @input="updateValue(options[$event.target.value] ? options[$event.target.value].value : null)"
                :id="id" 
                :class="'form-control' + (this.errors.has(this.name) ? ' form-control-warning' : '')" 
                :name="name"
                :disabled="disabled">
                <option v-if="placeholder" value="">{{ placeholder }}</option>
                <option v-for="(option, index) in options" :value="index" :selected="value === option.value ? 'selected' : false">{{ option.label }}</option>
            </select>
        </div>

        <span v-if="errors.has(name)" class="form-control-feedback">
            <strong>{{ errors.first(name) }}</strong>
        </span>
    </div>
</template>

<script>
    import FormValidationErrors from '../../../classes/FormValidationErrors.js';
    import Collection from '../../../classes/Collection.js';

    export default {
        name: 'VueSelect',

        props: {

            label: {},

            id: {
                default() { return _.camelCase(this.label); }
            },

            name: {
                default() { return _.kebabCase(this.label).replace('-', '_'); }
            },

            placeholder: {
                default() { return 'Select...'; }
            },
            
            options: {
                default() { return []; }
            },

            value: {},

            errors: {
                default() { return new FormValidationErrors(); }
            },

            disabled: {
                default() { return false; }
            },

            containerClasses: { default() { return ''; }}
        },

        data() {
            return {
                loadedOptions: new Collection(),
            }
        },

        methods: {
            updateValue(value) {
                /*let div = this.$el.querySelector('.custom-select');
                div.className = 'custom-select';*/

                this.$emit('input', value);
            }
        },

        computed: {
            formGroupClasses() {
                return 'form-group form-group-'+ _.kebabCase(this.name) + (this.errors.has(this.name) ? ' has-warning' : '')+ ' '+this.containerClasses;
            },
            holderClasses() {
                return (!this.value ? ' placeholder' : '');
            },
        }
    }
</script>